import { CREDIT_PACK } from '@str/shared';
import { useState } from 'react';
import type { CreditShortfall } from '@/lib/api';

/**
 * The wallet could not cover a run: says what it needs and what is there, and offers the ways
 * out the API named. Never a generic error. Starting the plan charges the card, so it asks once.
 */
export function CreditsShort({
  shortfall,
  busy,
  startCharge,
  onBuyPack,
  onStartPlan,
}: {
  shortfall: CreditShortfall;
  busy: boolean;
  /** "$194 today for Starter annual": what starting the plan now charges. */
  startCharge?: string;
  onBuyPack: () => void;
  onStartPlan: () => void;
}) {
  const [confirming, setConfirming] = useState(false);
  const s = (n: number) => (n === 1 ? '' : 's');
  const amount = startCharge?.split(' today')[0] ?? '';
  return (
    <div
      role="alert"
      className="a-rise"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 10,
        padding: '10px 14px',
        borderRadius: 12,
        background: 'var(--bg)',
        fontSize: 13,
      }}
    >
      {confirming ? (
        <>
          <span>Your card is charged {startCharge}. Your monthly credits land now.</span>
          <button
            type="button"
            className="btn-pill hv"
            disabled={busy}
            onClick={() => {
              setConfirming(false);
              onStartPlan();
            }}
          >
            Yes, start my plan
          </button>
          <button type="button" className="btn-pill hv" onClick={() => setConfirming(false)}>
            Not now
          </button>
        </>
      ) : (
        <>
          <span>
            This needs {shortfall.needed} credit{s(shortfall.needed)} and you have{' '}
            {shortfall.balance}.
          </span>
          {shortfall.actions.includes('buy_pack') && (
            <button type="button" className="btn-pill hv" disabled={busy} onClick={onBuyPack}>
              Buy {CREDIT_PACK.credits} credits for ${CREDIT_PACK.priceCents / 100}
            </button>
          )}
          {shortfall.actions.includes('start_plan') && startCharge && (
            <button
              type="button"
              className="btn-pill hv"
              disabled={busy}
              onClick={() => setConfirming(true)}
            >
              Start my plan now · {amount} today
            </button>
          )}
        </>
      )}
    </div>
  );
}
